import React from 'react';
import { BarChart2, Coins, Users, Diamond, History } from 'lucide-react';
import { useUI } from '../../contexts/UIContext';

const MainNavigation = () => {
  const { activeTab, setActiveTab, isMobile, isMobileMenuOpen } = useUI();

  const navItems = [
    { id: 'dashboard', icon: <BarChart2 size={20} />, label: 'Dashboard' },
    { id: 'invest', icon: <Coins size={20} />, label: 'Invest' },
    { id: 'team', icon: <Users size={20} />, label: 'Team' },
    { id: 'royalty', icon: <Diamond size={20} />, label: 'Royalty' },
    { id: 'activities', icon: <History size={20} />, label: 'Activities' }
  ];

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // Determine CSS class for mobile responsiveness
  const navClass = isMobile 
    ? `main-nav ${isMobileMenuOpen ? 'mobile-open' : 'mobile-closed'}`
    : 'main-nav';

  return (
    <nav className={navClass}>
      <div className="logo">
        <span className="primary">Grich</span><span className="secondary">Inv</span>
        <div className="logo-glow"></div>
      </div>
      <ul className="nav-links">
        {navItems.map((item) => (
          <li 
            key={item.id}
            className={activeTab === item.id ? 'active' : ''}
            onClick={() => handleTabClick(item.id)}
            data-tab={item.id}
          >
            {item.icon}
            <span style={{ marginLeft: '10px' }}>{item.label}</span>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default MainNavigation;